interface CodeAndName {
    code: string;
    name: string;
}

export type DropdownListItem<T> = {
    title: string;
    value: T;
};

export function mapToDropdownListItemWithCodeAndName<T extends CodeAndName>(
    object: T
): DropdownListItem<T> {
    return {
        title: `${object.code} - ${object.name}`,
        value: object,
    };
}
